import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDove,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import AddAveForm from "../Granja/Add/Forms/AddBatchForm/AddAveForm";
import "./MisGalpones.css";
import { useShoppingContext } from "../context/ShoppingContext";

const MisGalpones = () => {
  const {
    galpones,
    fetchMisGalpones,
    fetchMisAves,
    loading,
    aves,
    showAddAves,
    handleDeleteGalpon,
  } = useShoppingContext();
  const navigate = useNavigate();

  useEffect(() => {
    fetchMisGalpones();
    fetchMisAves();
  }, [fetchMisAves, fetchMisGalpones]);


  if (loading) {
    return <div className="text-center">Cargando...</div>;
  }

  return (
    <div className="">
      {/* <h2 className="text-center">
        Mis Galpones{" "}
        <span className="badge btn-green-outline">{galpones.length}</span>
      </h2> */}

      {/* Contenedor en dos columnas con CSS Grid */}
      <div className="galpones-grid mb-5">
        {galpones.map((galpon) => {
          // Calcular la sumatoria de aves.saldo para el galpón actual
          const totalAves = aves
            .filter((ave) => ave.galponId === galpon.id)
            .reduce((sum, ave) => sum + ave.saldo, 0);

          return (
            <div key={galpon.id} className="galpon-card">
              <h2 className="galpon-title">{galpon.nombre}</h2>
              <p>
                <strong>Total de aves:</strong>{" "}
                <FontAwesomeIcon
                  icon={faDove}
                  style={{ color: "rgb(222 208 17)" }}
                />{" "}
                {totalAves || 0}
              </p>

              {/* Mostrar detalles adicionales del galpón */}

              <div className="flex-space-between">
                <p>
                  <strong>Largo:</strong> {galpon.largo} mts.
                </p>
                <p>
                  <strong>Ancho:</strong> {galpon.ancho} mts.
                </p>
              </div>

              <div className="card-footer">
                <button
                  className="btn btn-green"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/edit-galpon/${galpon.id}`);
                  }}
                >
                  <FontAwesomeIcon icon={faEdit} /> Editar
                </button>
                <button
                  className="btn btn-green-outline"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteGalpon(galpon.id);
                  }}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {showAddAves && <AddAveForm />}
    </div>
  );
};

export default MisGalpones;
